import axios from "axios";

export const putCatchReportUnreview = async (catchReportID: number) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/CatchReport/unreview?CatchReportID=${catchReportID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
